import { i18n } from '@/i18n'

const defaultParsers = [
  { type: 'Any', callback: parseValue },
  // { type: Boolean, callback: value => value ? i18n.t('app.yes') : i18n.t('app.no') },
  { type: Boolean, callback: value => value ? '✔' : '✖' },
]

/**
 * Callback for parse the value.
 *
 * @callback callback
 * @param {*} value
 * @returns {String}
 */
/**
 * 
 * @param {Object} obj
 * @param {Object[]} obj.data 
 * @param {String[]} obj.headers 
 * @param {String} obj.fileName 
 * @param {{type: Constructor|String|'Any', callback: callback}[]} obj.parsers 
 */
function exportExcel ({ data, headers = [], fileName = '_.csv', parsers = defaultParsers }) {
  if (!fileName.endsWith('.csv')) {
    fileName += '.csv'
  }
  if (headers.length === 0) {
    headers = getDefaultHeaders(data).map(key => i18n.te(`excels.${key}`) || i18n.te(`excels.${key}`, i18n.locale) ? i18n.t(`excels.${key}`) : key)
  }
  checkData(data, headers, fileName)

  const header = '\uFEFF' + headers.join(';') + '\n'
  const content = data.reduce((a, b) => a + (valueParser(b, parsers).join(';') + '\n'), header)
  const link = document.createElement('a')
  const archivo = new Blob([content], { encoding: 'UTF-8', type: 'text/csv;charset=UTF-8' })
  const url = URL.createObjectURL(archivo)
  link.href = url
  link.download = fileName
  link.click()
  URL.revokeObjectURL(url)
}

/**
 * 
 * @param {Object[]} data 
 * @returns {String[]}
 */
function getDefaultHeaders (data) {
  const keys = data.map(x => Object.keys(x))
  const maxLength = Math.max(0, ...keys.map(x => x.length))
  return keys.find(x => x.length === maxLength) || []
}

function checkData (data, headers, fileName) {
  if (fileName.includes('.') && fileName.split('\\.')[1] === 'csv') {
    throw new Error(i18n.t('validation.not_permited_extension'))
  }
  if (headers.length !== getDefaultHeaders(data).length) {
    throw new Error(i18n.t('validation.not_same_num_headerss_value'))
  }
}

/**
 * 
 * @param {Object} data 
 * @param {{type: Constructor|String|'Any', callback: callback}[]} parsers 
 */
function valueParser (data, parsers) {
  const result = []
  for (const key in data) {
    const value = data[key]
    const parser = parsers.find(x => value.constructor === x.type) || parsers.find(x => value.constructor.name === x.type) || parsers.find(x => x.type === 'Any')
    result.push(parser ? parser.callback(value) : value)
  }
  return result
}

/**
 * Parsea el valor a string según las especificaciones genéricas
 * @param {*} value 
 * @returns {String}
 */
function parseValue (value) {
  return value
}

export { exportExcel }
